<template>
  <div class="notfound">
    <NotFound/>
  </div>
</template>

<script>
// @ is an alias to /src
import NotFound from '@/components/NotFound.vue'

export default {
  name: 'notfound',
  components: {
    NotFound
  }
}
</script>